import { applyPromptSharingPreset } from './promptPermissions';

const emptyPermissionArrays = {
  groupAccess: [],
  individualAccess: [],
  canEdit: [],
  canShare: [],
  canDelete: [],
  viewOnlyAccess: [],
};

export const PROJECT_IMPORT_VISIBILITY_LEVELS = ['private', 'team', 'organization', 'custom'];

export function applyContextSharingPreset(level, { userTeamId = null, creatorId = null, prevPermissions = {} } = {}) {
  if (level === 'team') {
    return {
      companyAccess: false,
      teamAccess: userTeamId ? [userTeamId] : [],
      ...emptyPermissionArrays,
    };
  }

  if (level === 'organization') {
    return {
      companyAccess: true,
      teamAccess: userTeamId ? [userTeamId] : [],
      ...emptyPermissionArrays,
    };
  }

  if (level === 'custom') {
    const existingIndividual = Array.isArray(prevPermissions.individualAccess) ? prevPermissions.individualAccess : [];
    const hasCreator = creatorId && existingIndividual.includes(creatorId);
    return {
      companyAccess: false,
      teamAccess: [],
      groupAccess: [],
      individualAccess: hasCreator || !creatorId ? existingIndividual : [creatorId, ...existingIndividual],
      canEdit: Array.isArray(prevPermissions.canEdit) ? prevPermissions.canEdit : [],
      canShare: Array.isArray(prevPermissions.canShare) ? prevPermissions.canShare : [],
      canDelete: Array.isArray(prevPermissions.canDelete) ? prevPermissions.canDelete : [],
      viewOnlyAccess: Array.isArray(prevPermissions.viewOnlyAccess) ? prevPermissions.viewOnlyAccess : [],
    };
  }

  return {
    companyAccess: false,
    teamAccess: [],
    ...emptyPermissionArrays,
  };
}

export function applyProjectImportSharingPreset(level, { userTeamId = null, creatorId = null, prevPermissions = {} } = {}) {
  const normalizedLevel = PROJECT_IMPORT_VISIBILITY_LEVELS.includes(level) ? level : 'private';
  const promptPreset = applyPromptSharingPreset(normalizedLevel, {
    userTeamId,
    creatorId,
    prevPermissions,
  });

  return {
    visibility: normalizedLevel,
    promptPermissions: promptPreset.permissions,
    promptPublishToCommunity: false,
    contextPermissions: applyContextSharingPreset(normalizedLevel, {
      userTeamId,
      creatorId,
      prevPermissions,
    }),
  };
}
